import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Messages, InfoMessageSchema } from '../types/infoMessageSchema';

const initialState: InfoMessageSchema = {
  MessageYellowSlot: false,
  MessageWhyChoose: false,
  MessageNewYearDraw: false,
  February23rdNotice: false,
  InfoJob: false,
};

export const infoMessageSlice = createSlice({
  name: 'infoMessage',
  initialState,
  reducers: {
    messageShow: (state, action: PayloadAction<Messages>) => {
      state[action.payload] = true;
    },
    messageHide: (state, action: PayloadAction<Messages>) => {
      state[action.payload] = false;
    },
  },
});

export const { actions: infoMessageActions } = infoMessageSlice;
